import React from "react";
import EscapeOutside from "react-escape-outside";

import KPIPerformanceGraph from "./KPIPerformanceGraph";
import KPIParametersSummaryTable from "./KPIParametersSummaryTable";
import UserProfile from "../../UserProfile/components/UserProfile";

const EmployeeDeepDiveModal = ({
  userData,
  employeeDataType = "kpi-parameters",
  setViewEmployeeDeepDive,
  metric = null,
}) => {
  return (
    <div className="kpi-modal-overlay">
      <EscapeOutside
        onEscapeOutside={() => {
          setViewEmployeeDeepDive(false);
        }}
      >
        <div className="kpi-modal">
          <div className="kpi-modal-body">
            {employeeDataType === "kpi-parameters" ? (
              <>
                <div className="geo-filter-bar">
                  <h2>Viewing all KPI parameters for {userData.username}</h2>
                </div>
                <KPIParametersSummaryTable
                  userId={userData.userId}
                  canViewBreakdown={false}
                />
              </>
            ) : employeeDataType === "user-profile" ? (
              <UserProfile
                userId={userData.userId}
                isOwnProfile={false}
                canUnregisterFacematch={false}
              />
            ) : employeeDataType === "performance-graph" ? (
              <KPIPerformanceGraph userId={userData.userId} metric={metric} />
            ) : (
              <div>Invalid Data Type</div>
            )}
          </div>
        </div>
      </EscapeOutside>
    </div>
  );
};

export default EmployeeDeepDiveModal;
